import { render } from "./BlogPanel.vue?vue&type=template&id=1902971a&scoped=true"
import script from "./BlogPanel.vue?vue&type=script&lang=js"
export * from "./BlogPanel.vue?vue&type=script&lang=js"

import "./BlogPanel.vue?vue&type=style&index=0&id=1902971a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1902971a"]])

export default __exports__